{
  "contact-update-dialog": {
    "buttons": {
      "confirm": "Bestätigen",
      "skip": "Überspringen"
    },
    "text": {
      "confirm-email": "E-Mail-Bestätigung",
      "confirm-email-hint": "Bitte bestätigen Sie Ihre E-Mail",
      "confirm-phone-number": "Telefonnummernbestätigung",
      "confirm-phone-number-hint": "Bitte bestätigen Sie Ihre Telefonnummer",
      "enter-email": "E-Mail ist nicht vorhanden",
      "enter-email-hint": "Bitte setzen Sie Ihre E-Mail",
      "enter-phone-number": "Telefonnummer ist nicht vorhanden",
      "enter-phone-number-hint": "Bitte setzen Sie Ihre Telefonnummer",
      "in-second": "in {{seconds}} s"
    }
  }
}
